let css = require('./price.css');
let Preloader = require('../../../layout/preloader');
let { cut } = require('../../../../helpers/utils');
let signals = require('../../../../signals/order');

const WARNING = cut(css.warning);

class Price {
    constructor () {
        this.template = require('./template.hbs');
    }

    bind () {
        return {
            mouseenter: {
                [WARNING]: this.showTooltip
            },
            mouseleave: {
                [WARNING]: this.hideTooltip
            }
        };
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    showTooltip () {
        this.$context.signal(signals.showTooltip);
    }

    hideTooltip () {
        this.$context.signal(signals.hideTooltip);
    }
}

module.exports = {
    constructor: Price,
    children: [
        {
            name: 'preloader',
            component: Preloader,
            props: {
                size: 'medium'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/order/header/price/index.js